export enum ChatIcons { //eslint-disable-line @stencil-community/ban-exported-const-enums
  QUESTION_ICON = 'user_standard',
  GENERAL_ICON = 'communication_bubbles1',
  THUMB_UP_ICON = 'thumbs-up',
  THUMB_DOWN_ICON = 'thumbs-down',
  INFORMATION_ICON = 'information_circle',
  INFORMATION_SOLID_ICON = 'information_circle_solid',
  SUCCESS_ICON = 'notification_ok_stroke',
  WARNING_ICON = 'notification_critical',
  ERROR_ICON = 'notification_error_plain',
  FEED_ICON = 'activity_feed',
  PAGE_ICON = 'page',
  CONTACT_SUPPORT_ICON = 'communication_bubbles2',
  SEE_OTHER_RESULTS = 'arrow2_down',
}

export enum ChatIconsColors { //eslint-disable-line @stencil-community/ban-exported-const-enums
  GENERAL_ICON_COLOR = 'alternative',
  STANDARD_ICON_COLOR = 'standard',
  INFORMATION_ICON_COLOR = 'secondary',
  SUCCESS_ICON_COLOR = 'success',
  WARNING_ICON_COLOR = 'warning',
}

export enum MessageType { //eslint-disable-line @stencil-community/ban-exported-const-enums
  NONE,
  LIKED,
  DISLIKED,
  NEW_CONVERSATION,
  MEDALIA_FALLBACK,
  CONTEXT_CHANGED,
  CONTEXT_LOSTED,
}

export enum ChatIconsColorsBackGround { //eslint-disable-line @stencil-community/ban-exported-const-enums
  GENERAL_ICON_COLOR_BACKGROUND = 'green',
  THUMBS_ICON_COLOR_BACKGROUND = 'transparent',
}

export enum CharacteristicsPartials { //eslint-disable-line @stencil-community/ban-exported-const-enums
  CHARACTERISTICS_DESCRIPTION = 'description',
  CHARACTERISTICS_TITLE = 'title',
}

export type SuggestionActions = Array<{
  action: string;
  callback: () => void;
  text: string;
}>;

export type ConversationalSearchQuestion = {
  question?: string;
  action?: string;
  type?: string;
};

export type ConversationalSearchFollowups = {
  followups?: Array<{
    id: string;
    type: string;
    message: string;
    displayName: string;
    categories?: string[];
    characteristics?: {
      name: string;
      values?: string[];
      value?: string;
    }[];
  }>
};

export type ConversationalSearchObsoleteProducts = {
  productIds: string[];
  commStatuses: {
    key: string;
    date: string;
    translation: string;
  }[];
};

type ConversationalSearchGeneralAnswer = {
  type: string;
  id: string;
  conversationId: string;
  createDate: string;
  converserName: string;
  query: string;
  persisted: boolean;
  requestId: string;
  context: {
    country: string;
    language: string;
    type: string;
  };
  detectedContext: {
    country: string;
    language: string;
    type: string;
    isFirstMessageInContext: boolean;
  };
};

export type ConversationalSearchRefinements = {
  name: string;
  values?: string[];
}[];

export type ConversationalSearchMessages =
  ConversationalSearchQuestion &
  ConversationalSearchAnswer &
  CovnersationalSearchAdditionalFields;

export type CovnersationalSearchAdditionalFields = {
  isFollowupFeedback?: boolean;
  isFollowupRefine?: boolean;
  isFollowupSatisfied?: boolean;
  isFollowupNotSatisfied?: boolean;
  isErrorResponse?: boolean;
};

export type ConversationalSearchProductHierarchy = {
  id: string;
  type: string;
  title: string;
  openUrl: string;
  thumbnailUrl: string | null;
  categoryL2?: string;
  categoryL2Translation?: string;
  summary?: string;
  subLevels?: Array<ConversationalSearchProductHierarchy>;
};

export type ConversationalSearchProductSuggestions = {
  id: string;
  type: string;
  title: string;
  openUrl: string;
  thumbnailUrl: string | null;
  justification?: string;
  productId?: string;
  characteristics?: Array<{
    name: string;
    values: string[];
  }>;
  popularityScore?: number;
  relevanceScore?: string;
  description?: string;
  commStatus?: {
    translation: string;
    key: string;
    date: string | null;
  };
};

export type ConversationalSearchResults = {
  results?: Array<
    ConversationalSearchProductHierarchy &
    ConversationalSearchProductSuggestions
  >;
};

export type ConversationalSearchAnswer =
  ConversationalSearchResults &
  ConversationalSearchFollowups &
  Partial<ConversationalSearchGeneralAnswer>;
